module.exports = __webpack_public_path__ + "img/fig03.e1bd269e.jpg";